import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import ProgressiveImage from "react-progressive-image";
class TopCategories extends Component {
    state = {
        top_categories : [],
    };

    componentDidMount(){
        axios
        .post('https://pykin.in/public/api/single-store/getCategories', {
            'id' : this.props.store_id
        })
        .then((response) => {
            const top_categories = response.data.top_categories;
            if (top_categories.length) {
                this.setState({
                    top_categories: top_categories
                });
            } else {
                this.setState({
                    top_categories: [],
                });
            }

        });
    }

    render() {

        
		return (
            <React.Fragment >
                <div className="text-center items-parrent ">

                    {this.state.top_categories.length > 0 && (
                        this.state.top_categories.map((category, index) => (
                            <DelayLink to={`/single-store-category/${category.id}/${this.props.store_id}`} className="items" key={index}>
                                <div><img src={'https://pykin.in/' + category.image } style={{width:'96%', height: 'auto'}} alt={category.name}/></div>
                                <div className="items-text">{category.name}</div>
                            </DelayLink>
                        ))
                   )}
                    
                   
                </div>        
            </React.Fragment>
        );
    }
}

export default TopCategories;